import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { QUERIES as i } from "@fcamna/shared-component-foundations";
import n, { css as S } from "styled-components";
import "react";
import { u as T } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Divider as y } from "./divider.js";
import { h } from "./hTag-27bb1617.mjs";
import { u as b } from "./useWindowDimensions-ae69e913.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const A = n.div`
  ${({ theme: { componentStyles: e } }) => S(e)};
  display: ${(e) => e.theme.components.pageHeader.PageHeaderWrapper.display};
  flex-direction: ${(e) => e.theme.components.pageHeader.PageHeaderWrapper.flexDirection};
  gap: ${(e) => e.theme.components.pageHeader.PageHeaderWrapper.gap};
`, D = () => `
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, P = n(h)`
  color: ${(e) => e.theme.components.pageHeader.TitleWrapper.color};

  ${({ $titleSize: e, ...t }) => {
  switch (e) {
    case "large":
      return t.theme.components.pageHeader.TitleWrapper.titleSize.large;
    case "extraLarge":
      return t.theme.components.pageHeader.TitleWrapper.titleSize.extraLarge;
    case "medium":
    default:
      return t.theme.components.pageHeader.TitleWrapper.titleSize.medium;
  }
}}
`, x = n.div`
  display: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.display};
  flex-direction: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.flexDirection};
  row-gap: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.rowGap};
  justify-content: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.justifyContent};
  padding: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.padding};

  background: ${({ $hideBackground: e, ...t }) => e ? t.theme.components.pageHeader.PageHeaderContainer.background.hide : t.theme.components.pageHeader.PageHeaderContainer.background.default};

  @media ${i.laptopAndUp} {
    padding: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.laptopAndUp.padding};
  }

  @media ${i.desktopAndUp} {
    padding: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.desktopAndUp.padding};
  }
  @media ${i.wideScreenAndUp} {
    padding: ${(e) => e.theme.components.pageHeader.PageHeaderContainer.wideScreenAndUp.padding};
  }
`, v = n.div`
  display: ${(e) => e.theme.components.pageHeader.TitleContainer.display};
  justify-content: ${(e) => e.theme.components.pageHeader.TitleContainer.justifyContent};
`, g = n.div`
  display: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.display};
  gap: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.gap};
  flex-direction: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.flexDirection};

  button {
    width: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.button.width};
  }

  @media ${i.tabletAndUp} {
    flex-direction: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.tabletAndUp.flexDirection};
    gap: ${(e) => e.theme.components.pageHeader.ActionButtonWrapper.tabletAndUp.gap};
  }
`, w = n(h)`
  align-self: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.alignSelf};
  color: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.color};
  font-family: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.fontFamily};
  font-size: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.fontSize};
  font-style: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.fontStyle};
  font-weight: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.pageHeader.SubTitleWrapper.lineHeight};
`, C = n.p`
  ${D()}
  align-self: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.alignSelf};
  color: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.color};
  font-family: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.fontFamily};
  font-size: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.fontSize};
  font-style: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.fontStyle};
  font-weight: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.pageHeader.DescriptionWrapper.lineHeight};
`, z = n.div`
  display: ${(e) => e.theme.components.pageHeader.TitleSubTitleWrapper.display};
  flex-direction: ${(e) => e.theme.components.pageHeader.TitleSubTitleWrapper.flexDirection};
  gap: ${(e) => e.theme.components.pageHeader.TitleSubTitleWrapper.gap};
`;
function R({
  title: e = "Pageheader title",
  children: t,
  actionButtons: r,
  titleProp: d = { size: "medium", title: e || "Pageheader title", headingLevel: "h1" },
  subTitleProp: m,
  description: l,
  hideBackground: H = !1,
  bottomStroke: f = !0,
  breadCrumbContent: s,
  tabContent: c,
  ...u
}) {
  const $ = T({ label: "Page Header" });
  let p = !1;
  const { width: W } = b();
  return W < 1024 ? p = !0 : p = !1, /* @__PURE__ */ o(
    x,
    {
      $hideBackground: H,
      ...u,
      ...$,
      children: [
        s && /* @__PURE__ */ a("div", { children: s }),
        /* @__PURE__ */ o(A, { children: [
          /* @__PURE__ */ o(z, { children: [
            /* @__PURE__ */ o(v, { children: [
              /* @__PURE__ */ a(
                P,
                {
                  $titleSize: d.size,
                  as: d.headingLevel,
                  children: d.title
                }
              ),
              !p && !!r && /* @__PURE__ */ a(g, { children: r })
            ] }),
            m && /* @__PURE__ */ a(w, { as: m.headingLevel, children: m.subTitle })
          ] }),
          l && /* @__PURE__ */ a(C, { children: l }),
          p && !!r && /* @__PURE__ */ a(g, { children: r })
        ] }),
        c && /* @__PURE__ */ a("div", { children: c }),
        t && /* @__PURE__ */ a("div", { children: t }),
        f && /* @__PURE__ */ a(y, {})
      ]
    }
  );
}
export {
  R as PageHeader
};
